module.exports = __webpack_public_path__ + "media/images/login_mobile-4945acc727604f9a7c761530876bd927.jpg";